const AUTHORIZED = 'AUTHORIZED';
const UNAUTHORIZED = 'UNAUTHORIZED';

export const types = {
  AUTHORIZED,
  UNAUTHORIZED
}

export const GET_CONFIGURATION = 'GET_CONFIGURATION';
export const GET_CONFIGURATION_SUCCESS = 'GET_CONFIGURATION_SUCCESS';
export const GET_CONFIGURATION_ERROR = 'GET_CONFIGURATION_ERROR';